export const BI_EVENTS = {
    CLICK: 'clicked_on_related_search',
    IMPRESSION: 'related_search_tag_is_shown',
    COMPONENT_NAME: 'related_search',
};
